import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from "../../apa/Launcher";
import DeviceStorage from "../../../components/DeviceStorage/DeviceStorage";
import Utils from '../../../utils/Utils';
import Search from '../../../utils/Search';

class ListRanking extends AbstractRequestTask {
  constructor(parameters) {
    super();
    this.customParameters = parameters;
  }
  
  getHeaders() {
    return {};
  }

  getParams() {
    const params = super.getParams();
    const epg_version = DeviceStorage.getItem('epgVersion');

    if(epg_version){
      this.customParameters.epg_version = epg_version;
    }
    return Object.assign({}, params, this.customParameters);
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");
    return `${http}${url}/services/list/ranking`;
  }

  parseErrors(err) {
    console.log('[UserFav] - api errors' +  err);
  }

  getRetriesNumber() {
        return 0;
  }

  getShowErrorModal(){
    return false;
  }

  success(data, b) {
    this.resolve(data);
  }
}

export default ListRanking;



// WEBPACK FOOTER //
// ./src/requests/tasks/search/ListRanking.js